angular.module('impactx.rfx').controller('RFXChangeSupportDateCtrl', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'ToastService',
    'TranslationService',
    RFXChangeSupportDateCtrl
]);

function RFXChangeSupportDateCtrl($scope, $mdDialog, dataGen, ToastService, TranslationService) {
    var ctrl = this;

    ctrl.getData = function () {
        var paramObj = {
            rfqsId: ctrl.rfqsId
        };
        dataGen.getData($scope, paramObj, '/rfx/support/activationdate/view').then(function () {
            if ($scope.trns) {
                $scope.trns.save = TranslationService.get('save');
                $scope.trns.cancel = TranslationService.get('abort');
            }
        });
    };

    ctrl.save = function () {
        var paramObj = {
            data: $scope.data
        };
        dataGen.postAsForm($scope, paramObj, '/rfx/support/activationdate/save').then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getData();
}